module.exports = __webpack_public_path__ + "static/img/guide_02.a8db205.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/guide_02.gif
// module id = XP0p
// module chunks = 1